module.exports = __webpack_public_path__ + "img/filter.2f4b6bec.svg";